<div class="sticky top-0 z-10 border-x-0 border-y-0 border-b border-solid border-pill bg-white px-2.5 py-2">
  <input
    #input
    type="text"
    autocomplete="off"
    class="box-border w-full rounded border-x border-y border-solid border-pill px-2 py-1.5 font-sans text-sm outline-none focus:border-theme-500"
    [placeholder]="placeholder"
    [attr.aria-label]="placeholder"
    [value]="term"
    (input)="onInput($any($event.target).value)"
    (keydown)="onKeydown($event)"
  />
</div>
<p *ngIf="noResultsText" class="m-0 px-3.5 py-2.5 text-sm text-gray-500">{{ noResultsText }}</p>
